<template>
  <div class="section-wrapper interimBox">
    <h2 class="section-title" v-if="!box.loading">
      {{ box.data.name }} ({{ box.data.cards.length }})
    </h2>
    <div class="actionWrapper">
      <div
        class="action"
        v-for="action in actions"
        :key="action.name"
        @click="performAction(action)"
      >
        {{ $t(action.title) }}
      </div>
    </div>
    <div
      v-if="
        box.data && box.data.quiz_results && box.data.quiz_results.length > 0
      "
      style="border-top:1px solid #e3e3e3;border-bottom:1px solid #e3e3e3;margin-top:10px;margin-bottom:10px;"
    >
      <div class="quiz-history">
        <BoxQuizHistory :quizHistory="box.data.quiz_results" :fancy="true" />
      </div>
    </div>
    <div v-else class="center-me no-sparks">
      {{ $t("earn sparks by scoring a quiz with score > 70% / 80% / 90%!") }}
    </div>

    <div
      v-if="
        box.data && box.data.quiz_results && box.data.quiz_results.length > 0
      "
    >
      <component v-bind:is="statisticsComponent"></component>
      <div class="center-me">
        <van-button
          class="statistics-toggle center-me"
          @click="toggleStatisticsComponent"
        >
          <span v-if="statisticsComponent == 'BoxLearnedWordsChart'">
            <i class="fas fa-chart-bar" />
            {{ $t("Details") }}
          </span>
          <span v-else>
            <i class="fas fa-chart-pie" /> {{ $t("Overview") }}
          </span>
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import BoxLearnedWordsChart from "@/components/chart/BoxLearnedWordsChart";
import BoxWordStatisticsCharts from "@/components/BoxWordStatisticsCharts";
import BoxQuizHistory from "@/components/BoxQuizHistory";
import formatTS from "@/mixins/momentMixin";

export default {
  name: "InterimBox",
  components: {
    BoxLearnedWordsChart,
    BoxWordStatisticsCharts,
    BoxQuizHistory
  },
  mixins: [formatTS],
  computed: {
    ...mapState("vokabel", ["box"]),
    ...mapGetters("vokabel", ["canEditBox", "hasBoxOwnerRights"]),
    actions() {
      const actions = [
        { title: "practice", name: "box", type: "link" },
        { title: "quiz", name: "box-quiz", type: "link" }
      ];
      if (this.canEditBox) {
        actions.push({ title: "edit", name: "box-edit", type: "link" });
      }
      if (this.hasBoxOwnerRights) {
        actions.push({ title: "delete", name: "box-delete", type: "delete" });
      }

      return actions;
    }
  },
  data() {
    return {
      boxId: null,
      statisticsComponent: "BoxLearnedWordsChart"
    };
  },
  methods: {
    ...mapActions("vokabel", ["getBoxInformation", "deleteBox"]),
    ...mapMutations("setting", ["SET_PAGE_TITLE", "SET_BACK_ROUTE"]),
    performAction({ type, name }) {
      if (type == "delete") {
        this.submitDeleteBox();
      }
      if (type == "link") {
        this.$router.push({ name, params: { id: this.boxId } });
      }
    },
    async submitDeleteBox() {
      try {
        await this.deleteBox(this.boxId);
        this.$router.push({ name: "my-boxes" });
      } catch (err) {
        //
      }
    },
    toggleStatisticsComponent() {
      this.statisticsComponent =
        this.statisticsComponent == "BoxLearnedWordsChart"
          ? "BoxWordStatisticsCharts"
          : "BoxLearnedWordsChart";
    }
  },
  created() {
    this.boxId = this.$route.params.id;
    this.getBoxInformation(this.boxId).then(() => {
      this.SET_PAGE_TITLE(this.box.data.name);
    });

    if (this.box.data.room) {
      this.SET_BACK_ROUTE({
        name: "classroom",
        params: {
          id: this.box.data.room
        }
      });
    } else {
      this.SET_BACK_ROUTE({
        name: "my-boxes"
      });
    }
  }
};
</script>

<style lang="scss">
.interimBox {
  .actionWrapper {
    display: flex;
    justify-content: center;

    .action {
      cursor: pointer;
      margin: 8px;
      width: 25%;
      border: 1px solid #e3e3e3;
      border-radius: 3px;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .statistics-toggle i {
    padding: 0 3px;
  }
  .no-sparks {
    padding: 0 7px;
  }
}
</style>
